import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'popup-footer, [popup-footer], [popupFooter], mir-popup-footer, [mir-popup-footer], [mirPopupFooter]',
    standalone: false
})
export class PopupFooterDirective {

  @HostBinding('class') hostCssClasses = 'mir-popup-footer popup-footer';

}
